import { Dispatch, SetStateAction } from 'react';

import { OnboardingStatusType } from 'api/types/entity';
import { SelectFilter } from 'components/Filters/SelectFilter';
import { useTranslation } from 'libs/i18n';

interface Props {
  statuses: OnboardingStatusType[];
  setStatuses: Dispatch<SetStateAction<OnboardingStatusType[]>>;
  excludeStatuses?: OnboardingStatusType[];
}

export const StatusFilter = ({
  statuses,
  excludeStatuses,
  setStatuses,
}: Props) => {
  const { t } = useTranslation();

  const items = Object.values(OnboardingStatusType)
    .filter((v) => !excludeStatuses?.includes(v))
    .map((v) => ({
      label: t(`client.status.${v}`),
      value: v,
    }));

  return (
    <SelectFilter
      activeValues={statuses}
      options={items}
      title={t('client.filters.status')}
      onChange={setStatuses}
    />
  );
};
